/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import subDays from 'date-fns/sub_days';
import subHours from 'date-fns/sub_hours';
import setHours from 'date-fns/set_hours';
import setMinutes from 'date-fns/set_minutes';
import startOfDay from 'date-fns/start_of_day';
import endOfDay from 'date-fns/end_of_day';
import differenceInCalendarDays from 'date-fns/difference_in_calendar_days';
import addDays from 'date-fns/add_days';
import isAfter from 'date-fns/is_after';
import isBefore from 'date-fns/is_before';
import min from 'date-fns/min';
import DatePicker from 'loracoms/DatePicker';
import TimePicker from 'loracoms/TimePicker';
import InlineSelect from 'loracoms/InlineSelect';
import IntlMsg from 'lorautils/intl/IntlMsg';
import roadtestActions from 'loraactions/roadtest';
import styles from './styles.scss';

const defaultTo = () => startOfDay(new Date());

const propTypes = {
  intl: PropTypes.object.isRequired,
  time: PropTypes.object.isRequired,
  getTimes: PropTypes.func.isRequired,
};

class TimeSelect extends React.Component {

  static handleDisableDate(d, from) {
    return isAfter(d, min(addDays(from, 7), new Date())) ||
      isBefore(d, from);
  }

  constructor(props) {
    super(props);
    this.state = {
      from: props.time.from,
      to: props.time.to,
      by: props.time.by || 'hour',
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.dashboard');
  }

  componentWillMount() {
    this.initBy();
  }

  initBy() {
    const { from, to, by } = this.props.time;
    if (!by) {
      const days = differenceInCalendarDays(to, from);
      let sort = 'hour';
      if (days <= 0) {
        sort = 'hour';
      } else if (days <= 1) {
        sort = 'day';
      } else if (days <= 7) {
        sort = 'sevenday';
      }
      this.setState({ by: sort });
    }
  }

  handleSetFrom(date) {
    const { from } = this.state;
    const to = endOfDay(date);
    let d = date;

    d = setMinutes(d, from.getMinutes());
    d = setHours(d, from.getHours());

    this.setState({ from: d, to }, () => {
      this.props.getTimes({ from: this.state.from, to });
    });
  }

  handleSetTo(date) {
    const { to } = this.state;
    let d = date;

    d = setMinutes(d, to.getMinutes());
    d = setHours(d, to.getHours());

    this.setState({ to: d }, () => {
      const { from } = this.state;
      this.props.getTimes({ from, to: this.state.to });
    });
  }

  handleSetMomentFrom(d) {
    let { from } = this.state;
    const { to } = this.state;

    from = setMinutes(from, d.getMinutes());
    from = setHours(from, d.getHours());
    this.setState({ from });

    this.props.getTimes({ from, to });
  }

  handleSetMomentTo(d) {
    let { to } = this.state;
    const { from } = this.state;

    to = setMinutes(to, d.getMinutes());
    to = setHours(to, d.getHours());
    this.setState({ to });

    this.props.getTimes({ from, to });
  }

  handleChangeBy(by) {
    const { getTimes } = this.props;
    const { to } = this.state;
    let from;
    let defaultto = defaultTo();
    defaultto = setMinutes(defaultto, to.getMinutes());

    switch (by) {
      case 'hour':
        from = setHours(defaultto, new Date().getHours());
        defaultto = setHours(defaultto, new Date().getHours() + 1);
        break;
      case 'day':
        from = subDays(defaultto, 1);
        from = setHours(from, this.state.from.getHours());
        defaultto = setHours(defaultto, to.getHours());
        break;
      case 'sevenday':
        from = subDays(defaultto, 7);
        from = setHours(from, this.state.from.getHours());
        defaultto = setHours(defaultto, to.getHours());
        break;
      case 'month':
        from = subDays(defaultto, 30);
        from = setHours(from, this.state.from.getHours());
        defaultto = setHours(defaultto, to.getHours());
        break;
      default:
        from = subHours(defaultto, 1);
    }

    from = setMinutes(from, this.state.from.getMinutes());

    this.setState({ by, from, to: defaultto });
    getTimes({ from, to, by });
  }

  render() {
    const { from, to, by, selectDisabled } = this.state;

    return (
      <div className={`${styles.timesel} clearfix`}>
        <DatePicker
          date={from}
          onSelect={date => this.handleSetFrom(date)}
        />
        <TimePicker
          date={from}
          onSelect={m => this.handleSetMomentFrom(m)}
        />
        <span className={styles.datesel}>
          <DatePicker
            date={to}
            onSelect={date => this.handleSetTo(date)}
            disabled={d => TimeSelect.handleDisableDate(d, from)}
          />
        </span>
        <TimePicker
          date={to}
          onSelect={c => this.handleSetMomentTo(c)}
        />
        <InlineSelect
          bsStyle="aisz-primary"
          options={[{
            label: this.intlMsg.msg('toolbar.bytime.hour'),
            value: 'hour',
          }, {
            label: this.intlMsg.msg('toolbar.bytime.day'),
            value: 'day',
          }, {
            label: this.intlMsg.msg('toolbar.bytime.sevenday'),
            value: 'sevenday',
          }]}
          values={[by]}
          disabled={selectDisabled}
          onChange={selected => this.handleChangeBy(selected[0])}
        />
      </div>
    );
  }
}

TimeSelect.propTypes = propTypes;

const mapStateToProps = state => ({
  time: state.roadtest.getTimes,
});

const mapDispatchToProps = {
  getTimes: roadtestActions.getTimes,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(TimeSelect));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/RoadTestView/coms/TimeSelect/index.jsx